import React from 'react';
import { excludeChildrenByType, findChildByType, renderChildren } from '@fiverr-private/ui_utils';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { ModalHeaderProps } from '../types';
import { useModalContext } from '../ModalContext';
import { MODAL_CLOSE_BTN_ID } from '../constants';

const ModalHeader = ({ children, floating = false }: ModalHeaderProps) => {
  const { centered, isDark } = useModalContext();
  const closeButton = findChildByType(children, MODAL_CLOSE_BTN_ID);
  const restOfChildren = excludeChildrenByType(children, MODAL_CLOSE_BTN_ID);

  return (
    <Stack
      position={floating ? 'absolute' : 'relative'}
      {...(floating && { top: 0, left: 0, right: 0 })}
      paddingY="4"
      paddingRight="6"
      paddingLeft={{ default: '6', md: '8' }}
      gap="0"
      color={isDark ? 'grey_300' : undefined}
    >
      <Container textAlign={centered ? 'center' : undefined} margin="auto" flex="1">
        <Heading as="h4" marginTop="2" color={isDark ? 'inherit' : undefined}>
          {renderChildren(restOfChildren)}
        </Heading>
      </Container>
      {renderChildren(closeButton)}
    </Stack>
  );
};

ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;
